var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2083 21.0938V19.0417C20.2083 17.9532 19.7759 16.9093 19.0062 16.1396C18.2366 15.3699 17.1927 14.9375 16.1042 14.9375H7.8958C6.80731 14.9375 5.76339 15.3699 4.99371 16.1396C4.22403 16.9093 3.79163 17.9532 3.79163 19.0417V21.0938",
    stroke: "#393949",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 10.8334C14.2666 10.8334 16.1041 8.99585 16.1041 6.72918C16.1041 4.4625 14.2666 2.625 11.9999 2.625C9.73325 2.625 7.89575 4.4625 7.89575 6.72918C7.89575 8.99585 9.73325 10.8334 11.9999 10.8334Z",
    stroke: "#393949",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.7390a35fbb84a355f3c7487ebc509d7c.svg";
export { ForwardRef as ReactComponent };